import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable()
export class MapService {


  message$ = {};
  private messageSource = {};

  create(mapId: number) {
    if (!this.messageSource[mapId]) {
      this.messageSource[mapId] = new Subject();
      this.message$[mapId] = this.messageSource[mapId].asObservable();
    }
  }

  next(mapId: number, value: any) {
    this.create(mapId);
    this.messageSource[mapId].next(value);
  }


  addLayer() {

  }
}
